var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUxResearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.25 48.75L50 52.5M10 52.5C10 42.835 17.835 35 27.5 35M47.5 43.75C47.5 47.2017 44.7017 50 41.25 50C37.7983 50 35 47.2017 35 43.75C35 40.2983 37.7983 37.5 41.25 37.5C44.7017 37.5 47.5 40.2983 47.5 43.75ZM37.5 17.5C37.5 23.0229 33.0228 27.5 27.5 27.5C21.9771 27.5 17.5 23.0229 17.5 17.5C17.5 11.9771 21.9771 7.5 27.5 7.5C33.0228 7.5 37.5 11.9771 37.5 17.5Z",
    stroke: "#25282B",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUxResearch);
export default __webpack_public_path__ + "static/media/Ux-Research.28d63aba77004a4b046ff414e215d2e0.svg";
export { ForwardRef as ReactComponent };